/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Dynamic Mega Menu Hover Image functionality
 * Changes the first image in .trigger-image-change based on the hovered link.
 */
document.addEventListener('DOMContentLoaded', () => {
  const menuLinks = document.querySelectorAll('.MegaMenu__Inner a.Link, .MegaMenu__Inner a.Header__Link, .MegaMenu__Item a');
  
  menuLinks.forEach(link => {
    link.addEventListener('mouseenter', handleMegaMenuHover);
  });

  const megaMenus = document.querySelectorAll('.MegaMenu');
  megaMenus.forEach(menu => {
    menu.addEventListener('mouseleave', handleMegaMenuLeave);
  });
});

function handleMegaMenuHover(e) {
  const link = e.target.closest('a');
  if (!link) return;

  const megaMenu = link.closest('.MegaMenu');
  if (!megaMenu) return;

  // Find the closest image block with the requested class
  // const triggerContainer = megaMenu.querySelector('.trigger-image-change') || megaMenu.querySelector('.MegaMenu__Push');
  const triggerContainer = megaMenu.querySelector('.trigger-image-change');
  if (!triggerContainer) return;

  const img = triggerContainer.querySelector('img');
  // Avoid changing if the user is hovering over the push block itself
  if (triggerContainer.contains(link)) return;

  const targetLink = triggerContainer.tagName === 'A' ? triggerContainer : triggerContainer.querySelector('a');
  const heading = triggerContainer.querySelector('.MegaMenu__PushHeading');

  if (!img) return;

  // Cache the original image and link states to restore on mouseleave
  if (!img.hasAttribute('data-original-src')) {
    img.setAttribute('data-original-src', img.src);
    img.setAttribute('data-original-srcset', img.srcset || '');
    if (targetLink) targetLink.setAttribute('data-original-href', targetLink.href);
    if (heading) heading.setAttribute('data-original-text', heading.innerText);
  }

  const linkUrl = link.href;
  const linkTitle = link.innerText.trim();

  // If the image for this link is already cached from a previous hover
  if (link.dataset.hoverImg) {
    applyHoverData(img, targetLink, heading, link.dataset.hoverImg, linkUrl, linkTitle);
    return;
  }

  // Dynamically fetch image from Shopify JSON API based on the hovered URL
  if (linkUrl.includes('/collections/') || linkUrl.includes('/products/')) {
    const fetchUrl = linkUrl.split('?')[0] + '.json';
    
    fetch(fetchUrl)
      .then(res => res.json())
      .then(data => {
        let imgSrc = '';
        if (data.collection && data.collection.image) {
          imgSrc = data.collection.image.src;
        } else if (data.product && data.product.image) {
          imgSrc = data.product.image.src;
        } else if (data.product && data.product.images && data.product.images.length > 0) {
          imgSrc = data.product.images[0].src;
        }

        if (imgSrc) {
          link.dataset.hoverImg = imgSrc;
          applyHoverData(img, targetLink, heading, imgSrc, linkUrl, linkTitle);
        }
      })
      .catch(err => console.error('Error fetching hover image:', err));
  }
}

function handleMegaMenuLeave(e) {
  const triggerContainer = this.querySelector('.trigger-image-change') || this.querySelector('.MegaMenu__Push');
  if (!triggerContainer) return;

  const img = triggerContainer.querySelector('img');
  const targetLink = triggerContainer.tagName === 'A' ? triggerContainer : triggerContainer.querySelector('a');
  const heading = triggerContainer.querySelector('.MegaMenu__PushHeading');

  // Restore the original image and link when leaving the megamenu
  if (img && img.hasAttribute('data-original-src')) {
    img.src = img.getAttribute('data-original-src');
    img.srcset = img.getAttribute('data-original-srcset');
    if (targetLink) targetLink.href = targetLink.getAttribute('data-original-href');
    if (heading) heading.innerText = heading.getAttribute('data-original-text');
  }
}

function applyHoverData(img, link, heading, src, href, title) {
  // Append dimensions for Shopify CDN images to ensure optimal loading
  let sizedSrc = src;
  if (!src.includes('_370x') && src.match(/\.(png|jpg|jpeg|gif|webp)(\?|$)/)) {
    sizedSrc = src.replace(/\.(png|jpg|jpeg|gif|webp)/, '_370x.$1');
  }
  
  img.src = sizedSrc;
  img.srcset = sizedSrc;
  
  // Support lazysizes attributes if theme requires it
  img.setAttribute('data-src', sizedSrc);
  img.setAttribute('data-srcset', sizedSrc);
  
  if (link) link.href = href;
  if (heading) heading.innerText = title;
}








/* Custom Desktop Search Injector */
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth < 1000) return;

  var domain = window.location.hostname;
  var placeholderText = domain.includes('verlichtingshuis.nl') ? 'Zoeken' : 'Search Here';

  var style = document.createElement('style');
  style.innerHTML = `
  .custom-desktop-search {
    display: none;
}
    @media screen and (min-width: 1140px) {
      .custom-desktop-search {
        display: flex;
        align-items: center;
        background-color: #dadada5e;
        border-radius: 25px;
        padding: 0 20px;
        margin: 0 15px;
        flex: 1;
        max-width: 600px;
        height: 45px;
        min-width: 550px;
      }
      .custom-desktop-search input {
        border: none;
        background: transparent;
        flex-grow: 1;
        outline: none;
        padding: 10px 0;
        font-size: 14px;
        color: #1c1b1b;
      }
      .custom-desktop-search input::placeholder {
        color: #939393;
        text-transform: uppercase;
      }
      .custom-desktop-search button {
        background: transparent;
        border: none;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        color: #1c1b1b;
      }
      .custom-desktop-search button svg {
        width: 20px;
        height: 20px;
      }
      .Header__Wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .Header__FlexItem--logo {
        flex: 0 0 auto;
      }
      .Header__FlexItem--icon {
        flex: 0 0 auto;
      }
    }
    @media screen and (max-width: 999px) {
      .custom-desktop-search {
        display: none !important;
      }
    }
  `;
  document.head.appendChild(style);

  var searchContainer = document.createElement('div');
  searchContainer.className = 'custom-desktop-search hidden-pocket';
  searchContainer.innerHTML = `
    <input type="text" id="custom-desktop-search-input" placeholder="` + placeholderText + `">
    <button id="custom-desktop-search-btn">
      <svg class="{{ icon_class }}" role="presentation" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
  <path d="M18.0585 9.02926C18.0585 11.0218 17.4117 12.8623 16.3221 14.3556L21.8178 19.8557C22.3604 20.3983 22.3604 21.2795 21.8178 21.8221C21.2752 22.3648 20.394 22.3648 19.8513 21.8221L14.3556 16.3221C12.8623 17.416 11.0218 18.0585 9.02926 18.0585C4.04146 18.0585 0 14.0171 0 9.02926C0 4.04146 4.04146 0 9.02926 0C14.0171 0 18.0585 4.04146 18.0585 9.02926ZM9.02926 15.2803C9.85015 15.2803 10.663 15.1186 11.4214 14.8044C12.1798 14.4903 12.8689 14.0299 13.4494 13.4494C14.0299 12.8689 14.4903 12.1798 14.8044 11.4214C15.1186 10.663 15.2803 9.85015 15.2803 9.02926C15.2803 8.20836 15.1186 7.3955 14.8044 6.63709C14.4903 5.87868 14.0299 5.18958 13.4494 4.60911C12.8689 4.02865 12.1798 3.56821 11.4214 3.25406C10.663 2.93992 9.85015 2.77823 9.02926 2.77823C8.20836 2.77823 7.3955 2.93992 6.63709 3.25406C5.87868 3.56821 5.18958 4.02865 4.60911 4.60911C4.02865 5.18958 3.56821 5.87868 3.25406 6.63709C2.93992 7.3955 2.77823 8.20836 2.77823 9.02926C2.77823 9.85015 2.93992 10.663 3.25406 11.4214C3.56821 12.1798 4.02865 12.8689 4.60911 13.4494C5.18958 14.0299 5.87868 14.4903 6.63709 14.8044C7.3955 15.1186 8.20836 15.2803 9.02926 15.2803Z" fill="#111827"/>
</svg>
    </button>
  `;

  var iconItem = document.querySelector('.Header__FlexItem.Header__FlexItem--icon');
  if (iconItem && iconItem.parentNode) {
    iconItem.parentNode.insertBefore(searchContainer, iconItem);
  } else {
    var headerWrapper = document.querySelector('.Header__Wrapper .Header__IconList');
    if (headerWrapper) {
      headerWrapper.prepend(searchContainer);
    }
  }

  var customInput = searchContainer.querySelector('#custom-desktop-search-input');
  var customBtn = searchContainer.querySelector('#custom-desktop-search-btn');
  var themeSearchElement = document.getElementById('Search');

  if (customInput) {
    customInput.addEventListener('input', function(e) {
      var val = e.target.value;
      var themeSearchInput = document.querySelector('.Search__Input');
      
      if (themeSearchInput) {
        themeSearchInput.value = val;
        themeSearchInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
      
      if (themeSearchElement) {
        if (val.trim() === '') {
          themeSearchElement.setAttribute('aria-hidden', 'true');
        } else {
          themeSearchElement.setAttribute('aria-hidden', 'false');
        }
      }
    });

    customInput.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var themeSearchForm = document.querySelector('.Search__Form');
        if (themeSearchForm) {
          themeSearchForm.submit();
        }
      }
    });
  }

  if (customBtn) {
    customBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var themeSearchForm = document.querySelector('.Search__Form');
      if (themeSearchForm) {
        themeSearchForm.submit();
      }
    });
  }
});